export async function saveOrderToBackend(orderData) {
  const res = await fetch('/api/flyghinder-order', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(orderData)
  });
  if (!res.ok) throw new Error("Kunde inte spara order");
  return await res.json();
}